import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { EnterpriseComponent } from './em-pages/enterprise/enterprise.component';

export const routes: Routes = [
  {  path: '',
  component: EnterpriseComponent,
  loadChildren: () => import('./em-pages/enterprise/enterprise.module')
    .then(m => m.EnterpriseModule),
},{
    path: 'em-pages/enterprise-module',   
    loadChildren: () => import('./em-pages/enterprise-module/enterprise-module.module')
      .then(m => m.EnterpriseModulModule),
  },
  
  {
    path: 'em-pages/customizing',
    loadChildren: () => import('./em-pages/customizing/customizing.module')
      .then(m => m.CustomizingModule),
  },
  {
    path: 'em-pages/resource-module',
    loadChildren: () => import('./em-pages/resource-module/resource-module.module')
      .then(m => m.ResourceModulModule),
  },
 /*  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        component: NbRegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
      },
    ],
  }, */
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
